import StockTransferImportFeature from "./StockTransferImportFeature";

export default StockTransferImportFeature;
